export enum ConditionClassEnum {
  XP01 = "XP01", // Precio
  XC01 = "XC01", // Ajuste de precio por descuento
  XR02 = "XR02", // Ajuste de precio por recargo
  XD02 = "XD02", // Descuento
  XG01 = "XG01" //Promoción
}